import { Row } from '@design-system/components/grid/grid';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const articleLink =
  'https://help.playbookapp.io/en/articles/9478261-how-to-create-a-challenge';

export const NeedHelpRow = () => (
  <Row>
    Need help? Read all about challenges on our{' '}
    <a
      href={articleLink}
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: 'underline', color: '#5e1ecc' }}
    >
      Help page
    </a>
  </Row>
);

export const HelpButton = () => (
  <Tooltip
    title={
      <div style={{ maxWidth: 130, padding: 8 }}>
        Need help? Read all about challenges on our Help page
      </div>
    }
    variant="dark"
  >
    <a
      href={articleLink}
      target="_blank"
      style={{ color: '#5e1ecc', marginTop: '8px' }}
      rel="noreferrer"
    >
      <Row alignCenter justifyCenter>
        <FontAwesomeIcon icon={faQuestionCircle} color="'#5e1ecc'" />
        <p>Help</p>
      </Row>
    </a>
  </Tooltip>
);
